import { render, staticRenderFns } from "./app-bar-version.vue?vue&type=template&id=1b383610&lang=pug&"
import script from "./app-bar-version.vue?vue&type=script&lang=ts&"
export * from "./app-bar-version.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports